import { render, staticRenderFns } from "./creativesOverview.vue?vue&type=template&id=db80849e&lang=pug"
import script from "./creativesOverview.vue?vue&type=script&lang=js"
export * from "./creativesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports